import { GNTNPLAY_HORSE_RACING_URL, GNTNPLAY_TYCHE_URL } from 'config';

export const UrlJsDeteils = {
  url_tyche: GNTNPLAY_TYCHE_URL,
  url_ippica: GNTNPLAY_HORSE_RACING_URL,
};

export const allUrlJsDeteilsIds = Object.values(UrlJsDeteils);

export const listApplicationCode = [
  { optionId: 1, label: 'SuperEnalotto SuperStar' },
  { optionId: 9, label: 'VinciCasa' },
  { optionId: 7, label: 'SiVinceTutto SuperEnalotto' },
  { optionId: 2, label: 'Vinci per la vita - Win For Life Classico' },
  //  { optionId: 4, label: "Vinci per la vita - Win For Life Viva l'Italia" },
  { optionId: 5, label: 'Vinci per la vita - Win For Life Grattacieli' },
  { optionId: 8, label: 'Eurojackpot' },
  { optionId: 10, label: 'Playsix' },
  { optionId: 27, label: 'Play Your Date' },
  { optionId: 28, label: 'Super Win For Life' },
];

export const listPeriodPlayState = [
  { label: 'Tutti', optionId: -1 },
  { label: 'Ultimi 7 giorni', optionId: 7 },
  { label: 'Ultimo mese', optionId: 30 },
  { label: 'Ultimi 3 mesi', optionId: 90 },
];

export const listPlayState = [
  { optionId: -1, label: 'Tutti' },
  { optionId: 1, label: 'Aperta' },
  { optionId: 2, label: 'Non Vincente' },
  { optionId: 3, label: 'Vincente' },
];

// The initial value of 'select-application-code'.
export const defaultSelectlistApplicationCodeOption =
  listApplicationCode[0].optionId;

// The initial value of 'select-play-state'.
export const defaultSelectlistPlayStateOption = listPlayState[0].optionId;

// The initial value of 'select-period'.
export const defaultSelectListPeriodPlayStateOption = listPeriodPlayState.find(
  (period) => period.optionId === 30,
)!.optionId;

export const statusLegend = {
  GREEN: 'lbl.winning',
  RED: 'lbl.not.winning',
  GREY: 'lbl.issued',
};

export const statusLottery = {
  3: 'RED',
  2: 'GREY',
  4: 'GREEN',
  5: 'GREEN',
};

export const allLotteryIds: { [key: string]: any } = statusLottery;
//export const allLotteryIds: any = Object.freeze(statusLottery);
